import { render } from "./PromotionTabApply.vue?vue&type=template&id=214f8558"
import script from "./PromotionTabApply.vue?vue&type=script&lang=js"
export * from "./PromotionTabApply.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__